module.exports = __webpack_public_path__ + "img/card-icon-mastercard.97473159.svg";